module.exports = __webpack_public_path__ + "static/service-restorations-3d566aa6d2e6bd3d3157ebb535583058.jpg";